<template>
  <div
    class="home"
  >
    <img src="../assets/samaggi.png" height="120" />
    <h1>My Samaggi Account</h1>
    <SignedInUser />
  </div>
</template>

<script>
import SignedInUser from '@/components/SignedInUser'

export default {
  name: 'Home',
  components: { SignedInUser }
}
</script>
<style>
.home{
  position: relative;
}
</style>
